// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__YZbCX menu-item_item__O_CDI","itemLink":"item_itemLink__KD3sO","itemLink--active":"item_itemLink--active__Q3f_y","itemIcon":"item_itemIcon__6zh8y"};